<template>
    <div class='col-md-8 px-0'>
        <v-overlay :value="overlay">
            <v-progress-circular
                indeterminate
                :absolute=true
                size="64"
            ></v-progress-circular>
        </v-overlay>
        <h1 class="orange--text mt-md-16 mt-0 font-title"><i>Para pedir cotización rellene este formulario:</i></h1>
        <v-form ref="form_quote">
            <v-row>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model=firstName
                        :rules=ruleRequire
                        outlined
                        dense
                        rounded
                    >
                        <template v-slot:label>
                            <span class='gray--text font-title'> <i>Nombre *</i></span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model=lastName
                        :rules=ruleRequire
                        outlined
                        dense
                        rounded
                    >
                        <template v-slot:label>
                            <span class='gray--text  font-title'> <i>Apellido *</i></span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model=email
                        :rules=mailRules
                        label="Email *"
                        outlined
                        dense
                        rounded
                    >
                        <template v-slot:label>
                            <span class='gray--text  font-title'> <i>Email *</i></span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        v-model=phone
                        :rules=ruleRequire
                        outlined
                        dense
                        rounded
                        type="number"
                    >
                        <template v-slot:label>
                          <span class='gray--text  font-title'> <i>Teléfono *</i></span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" md="6" >
                    <v-select
                        v-model=reason
                        :items=reasons
                        item-value="name"
                        item-text="name"
                        outlined
                        rounded
                        dense
                        label="Motivo de la consulta"
                        class='font-title'
                    ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field
                        v-model=company
                        :rules=ruleRequire
                        outlined
                        rounded
                        dense
                    >
                        <template v-slot:label>
                          <span class='gray--text  font-title'> <i>Empresa *</i></span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col 
                    cols="12" 
                    sm="6" 
                    v-if="$route.params.tipo!='importaciones' && $route.params.tipo!='representacion-marca'"
                >
                    <v-text-field
                        v-model=identification
                        :rules=ruleRequire
                        outlined
                        rounded
                        dense
                    >
                        <template v-slot:label>
                          <span class='gray--text  font-title'> <i>RUC *</i></span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col 
                    cols="12" 
                    sm="6" 
                    v-if="$route.params.tipo!='importaciones' && $route.params.tipo!='representacion-marca'"
                >
                    <v-text-field
                        v-model=employees
                        outlined
                        dense
                        rounded
                        type="number"
                    >
                        <template v-slot:label>
                          <span class='gray--text  font-title'><i>Número de empleados</i></span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col 
                    cols="12" 
                    v-if="$route.params.tipo=='importaciones' || $route.params.tipo=='representacion-marca'"
                >
                    <v-text-field
                        v-model=country
                        :rules=ruleRequire
                        outlined
                        rounded
                        dense
                    >
                        <template v-slot:label>
                          <span class='gray--text  font-title'> <i>PAÍS *</i></span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col
                    cols="12"
                >
                    <v-textarea 
                        outlined 
                        v-model=message
                    >
                        <template v-slot:label>
                          <span class='gray--text  font-title'><i>Describa su requerimiento</i></span>
                        </template>
                    </v-textarea>
                </v-col>
            </v-row>
            <v-col>
                <b><i class='gray--text  font-title'>(*) campos obligatorios</i></b>
                <v-btn 
                    rounded 
                    class='blue float-right white--text  font-title px-8'
                    @click="sendQuote"
                >
                    <b><i>Enviar</i></b>
                </v-btn>
            </v-col>
        </v-form>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import Vue from 'vue'
export default {
    name:'FormCotizacionComponent',
    data: ()=>({
        firstName:null,
        lastName:null,
        email:null,
        phone:null,
        reason:null,
        overlay:false,
        company:null,
        identification:null,
        employees:null,
        message:null,
        country:null,
        breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Cotización',url:'/empresas_pymes/cotizacion'}
        ],
        ruleRequire: [v => !!v || "El campo es obligatorio"],
        mailRules:[
            v => !!v || 'Debe escribir un correo electrónico',
            v => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Debe escribir un correo válido'
        ],
        reasons:[
            {name:'Insumos y equipos médicos'},
            {name:'Exámen pre y post ocupacionales'},
            {name:'Apto médico',},
            {name:'Chequeo ocupacionales preventivos'},
            {name:'Medicina de atención primaria'},
            {name:'Importaciones'},
            {name:'Representación de marca'}
        ],

    }),
    computed:{
        ...mapState(['sweealertForms'])
    },
    methods:{

        ...mapMutations(['setUrl']),

        ...mapActions(['requestApi']),
        
        sendQuote(){
            if(!this.$refs.form_quote.validate())
                return false

            this.setUrl('cotizacion-web/1')
            this.overlay=true
            this.requestApi({
				method: 'PATCH',
				data :{
                    firstName:this.firstName,
                    lastName:this.lastName,
                    email:this.email,
                    phone:this.phone,
                    reason:this.reason,
                    company:this.company,
                    identification:this.identification,
                    employees:this.employees,
                    message:this.message,
                    country:this.country,
                }
			}).then(res =>{
                Vue.swal({
                    title: res.data.detail,
                    ...this.sweealertForms
                })
                this.firstName=null
                this.lastName=null
                this.email=null
                this.phone=null
                this.reason=null
                this.company=null
                this.identification=null
                this.employees=null
                this.message=null
                this.country=null

			}).catch(()=>{

            }).then(()=>{
                this.overlay=false
            })

        }

    },
    mounted(){
        switch(this.$route.params.tipo){
            case 'insumos-equipos':
                this.reason='Insumos y equipos médicos'
                break
            case 'examen-pre-post-ocupacional':
                this.reason='Exámen pre y post ocupacionales'
                break
            case 'chequeo-ocupacional-preventivo':
                this.reason='Chequeo ocupacionales preventivos'
                break
            case 'apto-medico':
                this.reason='Apto médico'
                break
            case 'atencion-primaria':
                this.reason='Medicina de atención primaria'
                break
            case 'importaciones':
                this.reason='Importaciones'
                break
            case 'representacion-marca':
                this.reason='Representación de marca'
                break
        }
    },
    created(){
        this.$emit('newBreadcrumbs',this.breadcrumbs)
    }
}
</script>

<style scope>
    form fieldset {
        border:2px solid #26aeea!important
    }
</style>